/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 8/28/14
 * Time: 11:07 AM
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var GOAL_TYPE_CATEGORIES = {
        CONVERSION_GOALS    : 0,
        OTHER_GOALS         : 1
    };
    var GOAL_TYPES = {
        PURCHASE_PRODUCT    : 0,
        REDUCE_ABANDONMENT  : 1,
        FILL_FORM           : 2,
        OTHER               : 3,
        INCREASE_INTERACTION: 4,
        SERVICE_ACTIVITY    : 5
    };

    var AUTOMOTIVE_TYPES_TO_EXCLUDE = [
        GOAL_TYPES.FILL_FORM
    ];

    var INDICATOR_TYPES  = {
        URL                 : 0,
        MINIMUM_TOTAL_VALUE : 1,
        NUM_OF_PAGES        : 2,
        LEAD                : 4,
        SERVICE_ACTIVITY    : 5
    };

    var GOAL_TYPE_CATEGORIES_DEFINITIONS = {};
    GOAL_TYPE_CATEGORIES_DEFINITIONS[GOAL_TYPE_CATEGORIES.CONVERSION_GOALS] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.category.conversion"),
        tooltip:  LE.translator.translate("LECampaigns.goalDetailsView.type.category.conversion.tooltip"),
        types:  [GOAL_TYPES.PURCHASE_PRODUCT,GOAL_TYPES.FILL_FORM,GOAL_TYPES.SERVICE_ACTIVITY]
    };
    GOAL_TYPE_CATEGORIES_DEFINITIONS[GOAL_TYPE_CATEGORIES.OTHER_GOALS] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.category.other"),
        tooltip: LE.translator.translate("LECampaigns.goalDetailsView.type.category.other.tooltip"),
        types:  [GOAL_TYPES.REDUCE_ABANDONMENT,GOAL_TYPES.OTHER]
    };

    var GOAL_TYPE_DEFINITIONS = {};
    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.PURCHASE_PRODUCT] = {
        name:  LE.translator.translate("LECampaigns.goalDetailsView.type.label.purchaseProduct"),
        indicators:  [INDICATOR_TYPES.URL,INDICATOR_TYPES.MINIMUM_TOTAL_VALUE]
    };

    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.REDUCE_ABANDONMENT] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.label.reduceAbandonment"),
        indicators: [INDICATOR_TYPES.NUM_OF_PAGES]
    };

    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.FILL_FORM] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.label.FillForm"),
        indicators: [INDICATOR_TYPES.URL, INDICATOR_TYPES.LEAD]
    };

    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.OTHER] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.label.other"),
        indicators: [INDICATOR_TYPES.URL]
    };

    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.INCREASE_INTERACTION] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.label.increaseInteraction"),
        indicators: []
    };

    GOAL_TYPE_DEFINITIONS[GOAL_TYPES.SERVICE_ACTIVITY] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.type.label.serviceActivity"),
        indicators: [INDICATOR_TYPES.SERVICE_ACTIVITY]
    };
    var INDICATOR_TYPE_DEFINITIONS = {};
    INDICATOR_TYPE_DEFINITIONS[INDICATOR_TYPES.URL] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.url"),
        tooltip: ""
    };

    INDICATOR_TYPE_DEFINITIONS[INDICATOR_TYPES.LEAD] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.lead"),
        tooltip: ""
    };

    INDICATOR_TYPE_DEFINITIONS[INDICATOR_TYPES.MINIMUM_TOTAL_VALUE] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.minimumTotalValue"),
        tooltip: "" //LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.transaction.tooltip")
    };

    INDICATOR_TYPE_DEFINITIONS[INDICATOR_TYPES.NUM_OF_PAGES] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.numOfPages"),
        tooltip: ""
    };

    INDICATOR_TYPE_DEFINITIONS[INDICATOR_TYPES.SERVICE_ACTIVITY] = {
        name: LE.translator.translate("LECampaigns.goalDetailsView.indicatorType.serviceActivity"),
        tooltip: ""
    };

    var GoalUtilities = (function(){

        var getGoalTypeCategoriesObject = function() {
            return GOAL_TYPE_CATEGORIES;
        };
        var getGoalTypesObject = function() {
            return GOAL_TYPES;
        };
        var getGoalTypeName = function (goalTypeId) {
            if (_.isNull(goalTypeId) || !GOAL_TYPE_DEFINITIONS[goalTypeId]){
                return "";
            } else{
                return GOAL_TYPE_DEFINITIONS[goalTypeId].name ;
            }
        };
        var getIndicatorTypeName = function (indicatorId) {
            if (_.isNull(indicatorId) || !INDICATOR_TYPE_DEFINITIONS[indicatorId]){
                return "";
            } else{
                return INDICATOR_TYPE_DEFINITIONS[indicatorId].name ;
            }
        };
        var getIndicatorTypeTooltip = function (indicatorId) {
            if (_.isNull(indicatorId) || !INDICATOR_TYPE_DEFINITIONS[indicatorId]){
                return "";
            } else{
                return INDICATOR_TYPE_DEFINITIONS[indicatorId].tooltip ;
            }
        };
        var getIndicatorKeyValueArray = function(){
            var indicatorsKeyValueArray = _.map(_.keys(INDICATOR_TYPES),function (key){
                var indicatorId = INDICATOR_TYPES[key];
                return {
                    key: indicatorId,
                    value: INDICATOR_TYPE_DEFINITIONS[indicatorId].name
                };
            });

            return indicatorsKeyValueArray;
        };
        var getAllowedIndicatorKeyValueArray = function(goalType) {
            var indicatorsKeyValueArray = [];
            if (!_.isUndefined(goalType) && !_.isNull(goalType)) {
                indicatorsKeyValueArray = _.map(getAllowedIndicators(goalType), function (indicatorId) {
                    return {
                        key: indicatorId,
                        value: INDICATOR_TYPE_DEFINITIONS[indicatorId].name
                    };
                });
            }

            return indicatorsKeyValueArray;
        };

        var getGoalTypeArray = function(types) {
            types = types || _.values(GOAL_TYPES);
            if (LE.siteSettings.accountSettings.isAutomotive()) {
                types = _.difference(types, AUTOMOTIVE_TYPES_TO_EXCLUDE);
            }

            var goalTypeArray = _.map(types,function (goalId){
                return {
                    id:   goalId,
                    name: GOAL_TYPE_DEFINITIONS[goalId].name
                };
            });

            return goalTypeArray;

        };
        var getCategoriesFullArray = function(){
            var goalCategoriesArray = _.map(_.values(GOAL_TYPE_CATEGORIES),function (categoryId){
                return {
                    categoryId:   categoryId,
                    categoryName: GOAL_TYPE_CATEGORIES_DEFINITIONS[categoryId].name,
                    categoryTooltip:  GOAL_TYPE_CATEGORIES_DEFINITIONS[categoryId].tooltip,
                    items:        getGoalTypeArray(GOAL_TYPE_CATEGORIES_DEFINITIONS[categoryId].types)
                };
            });

            return goalCategoriesArray;
        };

        var getAllowedIndicators = function(goalType){
             return GOAL_TYPE_DEFINITIONS[goalType].indicators ;
        };

        var isOfTypeIncreaseInteraction = function(goalType){
            return goalType === GOAL_TYPES.INCREASE_INTERACTION;
        };

        var isOfTypeServiceActivity = function(goalType){
            return goalType === GOAL_TYPES.SERVICE_ACTIVITY;
        };

        return {
            getGoalTypesObject: getGoalTypesObject,
            getGoalTypeCategoriesObject: getGoalTypeCategoriesObject,
            getIndicatorKeyValueArray: getIndicatorKeyValueArray,
            getIndicatorTypeName: getIndicatorTypeName,
            getIndicatorTypeTooltip: getIndicatorTypeTooltip,
            getGoalTypeName:   getGoalTypeName,
            getGoalTypeArray:  getGoalTypeArray,
            getCategoriesFullArray:  getCategoriesFullArray,
            getAllowedIndicators: getAllowedIndicators,
            getAllowedIndicatorKeyValueArray: getAllowedIndicatorKeyValueArray,
            isOfTypeIncreaseInteraction: isOfTypeIncreaseInteraction,
            isOfTypeServiceActivity: isOfTypeServiceActivity
        };

    })();

    return GoalUtilities;
});
